module.exports = __webpack_public_path__ + "img/level_six_lock.ae0096cf.png";